import React, {useEffect} from "react";
import { GetProfileImages } from "../../DocumentDetails/slice";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { DEFAULT_AVATAR_URL, DEFAULT_COVER_URL } from "../../../common/enum";
import { Avatar, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

const ProfileAndBannerImage = ({
  bannerImageUrl,
  profilePictureUrl,
  entityName,
  lastMessageDate,
  donationId,
  collectionId,
  t,
}) => {
  const theme = useTheme();
  const replaceImage = (error) => {
    error.target.src = DEFAULT_AVATAR_URL;
  };
const dispatch = useDispatch();

  return (
    <Box
    className='messagecss'
      sx={{
        
        height: "160px",
        backgroundImage: `url(${
          bannerImageUrl === null || bannerImageUrl === "string"
            ? DEFAULT_COVER_URL
            : bannerImageUrl
        }),url(${DEFAULT_COVER_URL})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        position: "relative",
      }}
    >
      <Box
      className="covercss"
        sx={{
          // position: "absolute",
          width: "100%",
          height: "160px",
          bgcolor: "rgba(0, 0, 0, 0.54)",
          // display: "flex",
          // justifyContent: "flex-start",
        }}
      >
        <Avatar
          alt="Profile picture"
          src={
            profilePictureUrl === "string" || profilePictureUrl === null
              ? DEFAULT_AVATAR_URL
              : profilePictureUrl
          }
          onError={replaceImage}
          sx={{
            position: "absolute",
            backgroundColor: "green",
            margin: "0 30px",
            left: "0",
            right: "0",
            bottom: "0",
            borderRadius: "50%",
            width: "100px",
            height: "100px",
            transform: "translateY(50%)" /* additional 50% of own height */,
            boxShadow: "0 0 0 10px #fff",
            "& img": {
              height:
                (profilePictureUrl === DEFAULT_AVATAR_URL)
                  ? "100%"
                  : "100%",
              width:
                (profilePictureUrl === DEFAULT_AVATAR_URL)
                  ? "100%"
                  : "100%",
            },
          }}
        />
        <Typography
        className="entityNamecss"
          variant="h6"
          sx={{
            position: "absolute",
            color: "white",
            left: "143px",
            right: "0",
            bottom: "57%",
            fontSize: "1.50rem!important",
            "@media (max-width:500px)": {
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "inline-block",
              width: "59%",
              whiteSpace: "nowrap",
            },
          }}
        >
          {entityName}
        </Typography>
        <Box
        className="lastmessagereceivedcss"
          sx={{
            display: "flex",
            position: "absolute",
            left: "140px",
            right: "0",
            bottom: "10%",
            flexWrap: "wrap",
            flexDirection: "column"
          }}
        >
          {lastMessageDate && (
            <Typography
              variant="body2"
              sx={{
                color: "white",

                fontFamily: "Poppins",
                fontSize: "1rem!important",
                paddingLeft: "8px",
                "@media (max-width:1280px)": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  width: "90%",
                  whiteSpace: "nowrap",
                },
              }}
            >
              {" "}
              <span  title={`${t("lastMessageReceived")} ${lastMessageDate}`}>
                {t("lastMessageReceived")} {lastMessageDate}
              </span>
            </Typography>
          )}
          <Typography
            variant="body2"
            sx={{
              color: "white",
              ml: 1,
              fontFamily: "Poppins",
              fontSize: "1rem!important",
              "@media (max-width:1280px)": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                width: "90%",
                whiteSpace: "nowrap",
              },
            }}
          >
            {" "}
            <span title={`Código de doação`}>#{donationId}</span>
          </Typography>
          {collectionId !== "NaNundefined" && (
            <Typography
              variant="body2"
              sx={{
                color: "white",
                ml: 1,
                fontFamily: "Poppins",
                fontSize: "1rem!important",
                "@media (max-width:1280px)": {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "inline-block",
                  width: "90%",
                  whiteSpace: "nowrap",
                },
              }}
            >
              {" "}
              <span title={`Código de reserva`}>#{collectionId}</span>
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ProfileAndBannerImage;
